export const SITE = {
  brand: "SOS Serrurier Express",
  tagline: "Dépannage serrurerie 24h/24 · 7j/7",
  phone: "09 72 17 62 64",
  phoneHref: "tel:+33972176264",
  whatsapp: "+33766505505",
  whatsappDisplay: "07 66 50 55 05",
  whatsappHref: "https://wa.me/33766505505",
  area: "Intervention 24h/24",
  responseTime: "< 30 min",
  email: "contact@sos-serrurier-express.fr",
  address: "Serrurerie d'urgence multi-secteurs",
};

export const SERVICES = [
  {
    key: "ouverture",
    title: "Ouverture de porte",
    desc: "Porte claquée ou clé perdue ? Ouverture sans dégât dans 95% des cas, en moins de 30 minutes.",
    price: "Devis au téléphone",
    highlight: true,
    image:
      "https://customer-assets.emergentagent.com/job_emergency-lock-3/artifacts/7o3sd875_image0.png",
    poster: true,
  },
  {
    key: "depannage",
    title: "Dépannage serrurerie",
    desc: "Serrure bloquée, clé cassée, mécanisme grippé : intervention rapide 24h/24 avec devis transparent.",
    price: "24h/24 · 7j/7",
  },
  {
    key: "blindage",
    title: "Blindage de porte",
    desc: "Renforcez votre sécurité face aux tentatives d'effraction avec un blindage haute résistance.",
    price: "Sur mesure",
  },
  {
    key: "coffre",
    title: "Coffre-fort",
    desc: "Ouverture, installation et entretien de coffres-forts professionnels ou résidentiels.",
    price: "Sur devis",
  },
  {
    key: "connectee",
    title: "Serrure connectée",
    desc: "Installation de serrures connectées pilotables par smartphone : Nuki, Yale, Igloohome.",
    price: "Pose incluse",
    highlight: true,
  },
];

export const STATS = [
  { value: "< 30 min", label: "Temps d'intervention moyen" },
  { value: "24/7", label: "Disponibilité totale" },
  { value: "12 000+", label: "Interventions réalisées" },
  { value: "4,9/5", label: "Note clients vérifiés" },
];

export const TESTIMONIALS = [
  {
    name: "Claire M.",
    city: "Client vérifié",
    text: "Porte claquée à 2h du matin, intervention en 22 minutes. Serrurier pro, tarif exactement comme annoncé au téléphone. Bravo.",
    rating: 5,
  },
  {
    name: "Thomas B.",
    city: "Client vérifié",
    text: "Changement de serrure suite à une tentative d'effraction. Travail propre, conseils pertinents, devis respecté au centime près.",
    rating: 5,
  },
  {
    name: "Aminata D.",
    city: "Client vérifié",
    text: "J'avais peur d'être arnaquée en pleine nuit. Au contraire : devis annoncé, facture claire, technicien sympathique. Je recommande.",
    rating: 5,
  },
];

export const FAQ = [
  {
    q: "Combien coûte une ouverture de porte en urgence ?",
    a: "Nos interventions démarrent à 89€ en journée pour une porte claquée simple. Le tarif exact est toujours annoncé par téléphone avant déplacement et confirmé par devis avant toute intervention. Aucun frais caché.",
  },
  {
    q: "En combien de temps pouvez-vous intervenir ?",
    a: "En moyenne moins de 30 minutes dans votre secteur. Nos techniciens sont répartis sur plusieurs départements pour vous rejoindre au plus vite.",
  },
  {
    q: "Intervenez-vous la nuit et les jours fériés ?",
    a: "Oui, notre service d'urgence est disponible 24h/24, 7j/7, y compris les week-ends et jours fériés.",
  },
  {
    q: "Les serrures posées sont-elles certifiées ?",
    a: "Nous travaillons exclusivement avec du matériel certifié A2P (norme assurance) des marques reconnues : Picard, Fichet, Vachette, Bricard, Héraclès, Mul-T-Lock…",
  },
  {
    q: "Prenez-vous en charge les assurances ?",
    a: "Oui, nous fournissons une facture détaillée et un rapport d'intervention acceptés par toutes les compagnies d'assurance habitation.",
  },
];
